// place any theme constants you find here
export const borderRadius = {
    innerButton: 8,
    outerButton: 12,
};
export const borderWidth = {
    innerButton: 1.5,
    outerButton: 4,
};
export const sizes = {
    buttonHeight: 10,
    autoButtonPadding: 4,
    buttonIconSize: 7,
    buttonIconMinW: 28,
    buttonIconSpace: 1.5,
    textButtonIconSpace: 1,
};
